import React from 'react';
// the hook
import {useTranslation} from 'react-i18next';
import {history} from "../../libs";


import style from './index.module.less'
import pic2 from './business.png';
import pic3 from './advantage.png';
// import pic4 from './business3.png';


export default function () {
  const {t, i18n} = useTranslation();// {t('')}

  return (
    <div className={style.picBox}>
      {
        // i18n.language === 'zh' ? (
          <>
          {/* <div className={style.picBack}>
          </div> */}
          <img className={style.pic} src={pic2} alt=""/>
          <img className={style.pic} src={pic3} alt=""/>
          <div className={style.picBack1}>
          </div>
            {/* <img id='home' className={style.pic} src={pic2} alt=""/>
            <img id='ywjs' className={style.pic} src={pic3} alt=""/>
            <img id='service' className={style.pic} src={pic4} alt=""/> */}
          </>
      }

    </div>
  )
}
